import * as z from "zod/v4";

export const OMSMetricsRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
});

export const OMSMetricsResponseSchema = z.object({ value: z.number() });
